"use client";

import Cards from "@/components/content/cards";
import React from "react";
import { Card, CardBody } from "@nextui-org/react";
import { usePathname } from "next/navigation";
import FlatGenreScreen from "./flatGenreScreen";
import { GuideType } from "@/helpers/nextPlayGuideHelper";

const GenreSlugScreen = ({ data = {} }) => {
  const { children } = data?.result;
  const path = usePathname();

  const trimItems = (key) => {
    const items = data?.contents?.find((x) => x.key == key)?.data;
    if (items) {
      const _data = items.reduce(
        (acc, i) =>
          acc.concat({
            content: i,
          }),
        []
      );

      return _data;
    } else {
      return [];
    }
  };

  return (
    <div className="h-auto min-h-[100vh] w-full md:container mx-auto pb-40 px-5">
      {children?.length > 0 ? (
        <>
          <div className="w-full mt-52">
            <h2 className="font-medium sm:font-bold md:font-extrabold lg:font-black text-[#F0F0F0] text-3xl md:text-4xl lg:text-5xl z-10">
              {data?.result?.name}
            </h2>
          </div>
          {children?.length > 0 ? null : (
            <div className="w-full flex justify-center items-center mt-16">
              <Card className="dark px-24 py-5">
                <CardBody>
                  <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl text-[#BFBFBF]">
                    محتوایی یافت نشد.
                  </span>
                </CardBody>
              </Card>
            </div>
          )}
          <div className="w-full flex flex-col gap-10 mt-10">
            {children?.length > 0 ? (
              children?.map(
                (item) =>
                  trimItems(item.key)?.length > 0 && (
                    <Cards
                      items={trimItems(item.key)}
                      key={item.key}
                      isArtist={false}
                      noTag={false}
                      isMusic={false}
                      isSwiper={true}
                      categoryName={item.meta?.bin?.name}
                      actionLink={path + "/" + item.key}
                      hasExpand={true}
                      showTitle={true}
                      noContainer={true}
                      type="movie"
                      nextPlayGuide={{
                        type: GuideType.GENRE,
                        slug: item.key,
                        name: item.meta?.bin?.name,
                      }}
                    />
                  )
              )
            ) : (
              <div className="flex justify-center items-center pt-24">
                <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#BFBFBF]">
                  محتوایی یافت نشد.
                </span>
              </div>
            )}
          </div>
        </>
      ) : (
        <FlatGenreScreen data={data} />
      )}
    </div>
  );
};

export default GenreSlugScreen;
